/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';
import _ from 'underscore';

import * as OrganizationActions from 'actions/OrganizationActions';
import BenchlingConfig from 'BenchlingConfig';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {EntityWithText} from 'ui-library/entity-input/EntityInputConstants';
import {SingleEntityInput} from 'ui-library/entity-input/SingleEntityInput';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';

import {Member, MemberInvite, MemberRequest} from './OrganizationConstants';

interface Props {
  organizationId: string;
  organizationMembers?: Array<Member>;
  organizationMemberInvites?: Array<MemberInvite>;
  organizationMemberRequests?: Array<MemberRequest>;
}

/**
 * Input to allow searchings for users to add or invite to the org.
 */
class AddMemberInput extends React.Component<Props> {
  _handleSubmit = ({entity, email}: any): void => {
    // If the provisioning tool is enabled, add the user directly to the org, since that's what the
    // provisioning tool does. Otherwise, invite the user to the org (which may be auto-accepted if the user
    // had already requested to be added).
    if (BenchlingConfig.ENABLE_USER_PROVISIONING) {
      OrganizationActions.addMember(this.props.organizationId, entity);
    } else {
      OrganizationActions.inviteUser(this.props.organizationId, (entity && entity.handle) || email);
    }
  };

  _filterMembers = (tag: any, options: Array<EntityWithText>): Array<EntityWithText> => {
    // If the organization members/requests haven't loaded, don't filter existing members/requests.
    if (
      !this.props.organizationMembers ||
      !this.props.organizationMemberInvites ||
      !this.props.organizationMemberRequests
    ) {
      return options;
    }
    // Remove any users already in the organization or already invited.
    const existingUsers = (this.props.organizationMembers as Array<{email: string}>)
      .concat(this.props.organizationMemberInvites)
      .concat(this.props.organizationMemberRequests.map(({user}) => user));
    // eslint-disable-next-line no-restricted-syntax
    return _.reject(options, (option) =>
      Boolean(
        _.findWhere(existingUsers, {email: option.email}) ||
          _.findWhere(existingUsers, {handle: option.handle})
      )
    );
  };

  override render(): JSX.Element {
    return (
      <SingleEntityInput
        addKeys={[13]}
        allowEmails={BenchlingConfig.ENABLE_USER_SIGNUPS && !BenchlingConfig.ENABLE_USER_PROVISIONING}
        allowTeams={false}
        allowOrganizations={false}
        buttonProps={{
          buttonStyle: ButtonStyle.SECONDARY,
          size: ButtonSize.SMALL,
          text: BenchlingConfig.ENABLE_USER_PROVISIONING ? 'Add' : 'Invite',
        }}
        filterOptions={this._filterMembers}
        onSubmit={this._handleSubmit}
        size={TagsInputSize.SMALL}
      />
    );
  }
}

export default AddMemberInput;
